'use client';

import { TabsToolbar, tabsToolbarTag } from '@ni/nimble-components/dist/esm/tabs-toolbar';
import { wrap } from '../utilities/react-wrapper';

export { tabsToolbarTag };
export { type TabsToolbar };
export const NimbleTabsToolbar = wrap(TabsToolbar);
